module.exports = {
  id: 34,
  first_name: 'Mock',
  last_name: 'User',
  email: 'mockuser@reflowhub.com',
  locale: 'en',
  company_type: 'Admin',
  time_zone: 'Australia/Sydney'
}
